import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileUploadValidators } from '@iplab/ngx-file-upload';
import { ToastrService } from 'ngx-toastr';
import { OnboardingService } from '../../onboarding.service';
import { SheetMetalComponent } from '../sheet-metal/sheet-metal.component';

interface DialogData {

}

@Component({
  selector: 'app-edit-machine-details',
  templateUrl: './edit-machine-details.component.html',
  styleUrls: ['./edit-machine-details.component.scss']
})
export class EditMachineDetailsComponent implements OnInit {

  edit_machine_data;
  machineForm: FormGroup;
  machines;
  editMachineIndex;
  selectedManufacturingTechnology;
  selectedMachine: any;
  machineUnits;
  manufacturingTechnology;
  masterSpecs;
  machineFormSubmitted = false;
  keywordMachines = 'name';
  keyword = 'name';
  availableAddresses: any;
  manufacturingTechnologyData;
  machine_index
  machineDetailsArray;

  brands: any;
  keywordBrand = 'name';

  keywordSpecs = 'name';
  imagesArray: any

  private filesControl = new FormControl(null, FileUploadValidators.filesLimit(4));

  public demoForm = new FormGroup({
    files: this.filesControl
  });

  constructor(
    private fb: FormBuilder,
    private onboardingService: OnboardingService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogref: MatDialogRef<SheetMetalComponent>,
  ) {
    // this.selectedMachine.display_name == "Lasercutting"
  }

  ngOnInit() {
    this.machine_index = this.data["data"];
    this.edit_machine_data = this.data["machine_spec"]
    this.manufacturingTechnologyData = { id: this.edit_machine_data.manufacturing_technology_id, name: this.edit_machine_data.manufacturing_technology_name }
    console.log(this.manufacturingTechnologyData)
    this.machineDetailsArray = [];
    this.imagesArray = []
    console.log(this.edit_machine_data)
    this.setMachineFields();
    this.editFromMachineArray(this.edit_machine_data, this.machine_index)
    // this.setManufacturingTechnologyData(this.manufacturingTechnologyData)
  }

  get mf() { return this.machineForm.controls; }

  setMachineFields() {
    this.machineForm = this.fb.group({
      'machine_name': ["", Validators.required],
      'brand_name': ["", Validators.required],
      'machine_speciality': "",
      'model_number': ["", Validators.required],
      'number_of_machines': ["", [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(1)]],
      'spare_capacity': ["", [Validators.required, Validators.min(0), Validators.max(100)]],
      'is_available_for_rent': [false, Validators.required],
      'address_id': ["", Validators.required],
      'manufacturing_technology_id': ["", Validators.required],
      "manufacturing_technology_name": "",
      'vom_specifications': this.fb.array([]),
      'vom_attachments': this.imagesArray,
      'laser_type': "",
      'laser_power': "",
      'laser_power_unit': "kW",
      'max_sheet_thickness_mild_steel': "",
      'max_sheet_thickness_stainless_steel': "",
      'max_sheet_thickness_aluminium': "",
      'max_sheet_thickness_copper': "",
      'max_sheet_thickness_brass': "",
      'max_sheet_thickness_mild_steel_unit': "mm",
      'max_sheet_thickness_stainless_steel_unit': "mm",
      'max_sheet_thickness_aluminium_unit': "mm",
      'max_sheet_thickness_copper_unit': "mm",
      'max_sheet_thickness_brass_unit': "mm",
      'working_range_x': "",
      'working_range_y': "",
      'working_range_x_unit': "mm",
      'working_range_y_unit': "mm",
      'cutting_gas_oxygen': "",
      'cutting_gas_nitrogen': "",
      'cutting_gas_compressed_air': "",
      'marking_possible': "",
      'punch_force': "",
      'punch_force_unit': "",
      'sheet_thickness': "",
      'sheet_thickness_unit': "mm",
      'tool_stations': "",
      'tooling_diameter': "mm",
      'tooling_diameter_unit': "",
      'no_of_indexing_stations': "",
      'indexing_diameter': "",
      'indexing_diameter_unit': "mm",
      'additional_process_available': "forming",
      'forming_max_dimensions': "",
      'forming_max_height': "",
      'forming_max_angle': "",
      'forming_max_dimensions_unit': "mm",
      'forming_max_height_unit': "mm",
      'forming_max_angle_unit': "Degree",
      'max_sheet_thickness_punching': "",
      'max_sheet_thickness_punching_unit': "mm",
      'bending_length': "",
      'bending_length_unit': "mm",
      'free_passage_between_pillars': "",
      'free_passage_between_pillars_unit': "mm",
      'bending_aids': "hydraulic",
      'support_brackets': "",
      'total_number_of_panel_benders': "",
      'welding_type': "",
      'max_seam_length': "",
      'max_seam_length_unit': "mm",
      'no_of_rolls': "",
      'max_sheet_width': "",
      'max_sheet_width_unit': "mm",
    });

    this.onboardingService.getVendorOwnedMachines().subscribe(
      res => {
        this.machineDetailsArray = res;
      }, err => {
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      }
    );

    this.onboardingService.getAvailableAddresses().subscribe(
      res => {
        this.availableAddresses = res;
      }, err => {
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      }
    );


  }





  addMachineSpec() {
    (this.machineForm.get('vom_specifications') as FormArray).push(this.fb.group({
      master_specification_name: ["", Validators.required],
      machine_capacity: ["", Validators.required],
      machine_specification_unit_name: ["", Validators.required],
    }));
  }

  removeMachineSpec(idx) {
    (this.machineForm.get('vom_specifications') as FormArray).removeAt(idx);
    console.log(this.machineForm.value)
  }

  onChangeMachineSearch(event) {
    // console.log(event)
  }

  onMachineSelectSetSpecs(item) {
    this.selectedMachine = item;
    if (this.selectedManufacturingTechnology.name != "Sheet Metal Manufacturing") {
      this.onboardingService.getMachineRelatedSpecs(item.id).subscribe(
        res => {
          // if(res.length > 0){
          this.masterSpecs = res;
          console.log(this.masterSpecs)
          // }
          // this.loaderService.display(false);
        },
        err => {
          // this.loaderService.display(false);
          for (let i in err.error.errors) {
            this.toastr.error(err.error.errors[i]);
          }
        });
    } else {
      // this.loaderService.display(false);
    }
  }

  onChangeBrandSearch(val: string) {
    val = val.toLowerCase();
    this.onboardingService.searchBrands(val).subscribe(
      (res: any) => {
        this.brands = res;
        console.log(this.brands)
      },
      err => {
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      });
  }

  markAsRead() {
    this.machineForm.get('brand_name').markAsTouched();
  }

  uploadFactoryImage(event: any) {
    for (var i = 0; i < event.target.files.length; i++) {
      if (event.target.files[i].size < 10940000) {
        this.imagesArray.push(event.target.files[i])
      }
      else {
        return this.toastr.error('Please upload file less than 10 mb', 'Error');
      }
    }
    this.machineForm.get('vom_attachments').setValue(this.imagesArray)
    console.log(this.machineForm.get('vom_attachments'))
  }

  machineOnRent(event) {
    if (event.checked == true) {
      this.machineForm.get('is_available_for_rent').setValue(true)
    }
    else {
      this.machineForm.get('is_available_for_rent').setValue(false)
    }
  }

  cuttingGases(value) {
    if (value == 'oxygen') {
      this.machineForm.controls['cutting_gas_oxygen'].setValue("Oxygen")
    }
    else if (value == 'nitrogen') {
      this.machineForm.controls['cutting_gas_nitrogen'].setValue("Nitrogen")
    }
    else if (value == 'compressed air') {
      this.machineForm.controls['cutting_gas_compressed_air'].setValue("Compressed Air")
    }
  }

  editFromMachineArray(item, idx) {
    console.log(item)




    this.selectedManufacturingTechnology = { name: item.manufacturing_technology_name }
    this.selectedMachine = { name: item.vendor_machine_name, display_name: item.vendor_machine_display_name || item.vendor_machine_name }
    console.log(this.selectedMachine)
    this.editMachineIndex = idx;
    this.machineForm.reset()

    this.onboardingService.searchMachines(item.manufacturing_technology_id, "").subscribe(
      res => {
        this.machines = res;
      },
      err => {
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      });

    this.machineForm.controls['machine_name'].setValue(item.vendor_machine_display_name || item.vendor_machine_name)
    this.machineForm.controls['brand_name'].setValue(item.brand_name)
    this.machineForm.controls['machine_speciality'].setValue(item.machine_speciality)
    this.machineForm.controls['model_number'].setValue(item.model_number)
    this.machineForm.controls['number_of_machines'].setValue(item.number_of_machines)
    this.machineForm.controls['spare_capacity'].setValue(item.spare_capacity)
    this.machineForm.controls['address_id'].setValue(item.address_id)
    this.machineForm.controls['manufacturing_technology_id'].setValue(item.manufacturing_technology_id)
    this.machineForm.controls['manufacturing_technology_name'].setValue(item.manufacturing_technology_name)
    this.machineForm.controls['is_available_for_rent'].setValue(item.is_available_for_rent)
    this.machineForm.controls['vom_attachments'].setValue(item.vom_attachments)
    this.imagesArray = this.machineForm.get('vom_attachments').value

    if (this.selectedMachine.display_name == "Lasercutting" || this.selectedMachine.display_name == "lasercutting") {
      item.vom_specifications.forEach(function (spec) {
        if (spec.master_specification_name == "Laser Type") {
          this.machineForm.controls['laser_type'].setValue(spec.machine_capacity)
        } else if (spec.master_specification_name == "Laser Power") {
          this.machineForm.controls['laser_power'].setValue(spec.machine_capacity)
          this.machineForm.controls['laser_power_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Max Sheet Thickness Mild Steel") {
          this.machineForm.controls['max_sheet_thickness_mild_steel'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_thickness_mild_steel_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Max Sheet Thickness Stainless Steel") {
          this.machineForm.controls['max_sheet_thickness_stainless_steel'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_thickness_stainless_steel_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Max Sheet Thickness Aluminium") {
          this.machineForm.controls['max_sheet_thickness_aluminium'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_thickness_aluminium_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Max Sheet Thickness Copper") {
          this.machineForm.controls['max_sheet_thickness_copper'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_thickness_copper_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Max Sheet Thickness Brass") {
          this.machineForm.controls['max_sheet_thickness_brass'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_thickness_brass_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Working Range X") {
          this.machineForm.controls['working_range_x'].setValue(spec.machine_capacity)
          this.machineForm.controls['working_range_x_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Working Range Y") {
          this.machineForm.controls['working_range_y'].setValue(spec.machine_capacity)
          this.machineForm.controls['working_range_y_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Cutting Gas Oxygen") {
          this.machineForm.controls['cutting_gas_oxygen'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Cutting Gas Nitrogen") {
          this.machineForm.controls['cutting_gas_nitrogen'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Cutting Gas Compressed Air") {
          this.machineForm.controls['cutting_gas_compressed_air'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Marking Possible") {
          this.machineForm.controls['marking_possible'].setValue(spec.machine_capacity)
        }
      }, this)

    } else if (this.selectedMachine.display_name == "Punching" || this.selectedMachine.display_name == "punching") {
      item.vom_specifications.forEach(function (spec) {
        if (spec.master_specification_name == "Punch Force") {
          this.machineForm.controls['punch_force'].setValue(spec.machine_capacity)
          this.machineForm.controls['punch_force_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Sheet Thickness (Max)") {
          this.machineForm.controls['sheet_thickness'].setValue(spec.machine_capacity)
          this.machineForm.controls['sheet_thickness_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Tool Stations") {
          this.machineForm.controls['tool_stations'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Tooling Diameter (Max)") {
          this.machineForm.controls['tooling_diameter'].setValue(spec.machine_capacity)
          this.machineForm.controls['tooling_diameter_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "No. of indexing stations") {
          this.machineForm.controls['no_of_indexing_stations'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Indexing diameter(Max)") {
          this.machineForm.controls['indexing_diameter'].setValue(spec.machine_capacity)
          this.machineForm.controls['indexing_diameter_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Additional Process Available") {
          this.machineForm.controls['additional_process_available'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Working Range X") {
          this.machineForm.controls['working_range_x'].setValue(spec.machine_capacity)
          this.machineForm.controls['working_range_x_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Working Range Y") {
          this.machineForm.controls['working_range_y'].setValue(spec.machine_capacity)
          this.machineForm.controls['working_range_y_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Forming Max Dimensions") {
          this.machineForm.controls['forming_max_dimensions'].setValue(spec.machine_capacity)
          this.machineForm.controls['forming_max_dimensions_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Forming Max Height") {
          this.machineForm.controls['forming_max_height'].setValue(spec.machine_capacity)
          this.machineForm.controls['forming_max_height_unit'].setValue(spec.machine_specification_unit_name)
        }
        else if (spec.master_specification_name == "Max Angle") {
          this.machineForm.controls['forming_max_angle'].setValue(spec.machine_capacity)
          this.machineForm.controls['forming_max_angle_unit'].setValue(spec.machine_specification_unit_name)
        }
      }, this)

    } else if (this.selectedMachine.display_name == "Combi Machines" || this.selectedMachine.display_name == "combi machines") {
      item.vom_specifications.forEach(function (spec) {
        if (spec.master_specification_name == "Laser Type") {
          this.machineForm.controls['laser_type'].setValue(spec.machine_capacity)
        } else if (spec.master_specification_name == "Laser Power") {
          this.machineForm.controls['laser_power'].setValue(spec.machine_capacity)
          this.machineForm.controls['laser_power_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Max Sheet Thickness Mild Steel") {
          this.machineForm.controls['max_sheet_thickness_mild_steel'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_thickness_mild_steel_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Max Sheet Thickness Stainless Steel") {
          this.machineForm.controls['max_sheet_thickness_stainless_steel'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_thickness_stainless_steel_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Max Sheet Thickness Aluminium") {
          this.machineForm.controls['max_sheet_thickness_aluminium'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_thickness_aluminium_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Max Sheet Thickness Copper") {
          this.machineForm.controls['max_sheet_thickness_copper'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_thickness_copper_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Max Sheet Thickness Brass") {
          this.machineForm.controls['max_sheet_thickness_brass'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_thickness_brass_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Working Range X") {
          this.machineForm.controls['working_range_x'].setValue(spec.machine_capacity)
          this.machineForm.controls['working_range_x_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Working Range Y") {
          this.machineForm.controls['working_range_y'].setValue(spec.machine_capacity)
          this.machineForm.controls['working_range_y_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Cutting Gas Oxygen") {
          this.machineForm.controls['cutting_gas_oxygen'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Cutting Gas Nitrogen") {
          this.machineForm.controls['cutting_gas_nitrogen'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Cutting Gas Compressed Air") {
          this.machineForm.controls['cutting_gas_compressed_air'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Marking Possible") {
          this.machineForm.controls['marking_possible'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Max sheet thickness Punching") {
          this.machineForm.controls['max_sheet_thickness_punching'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_thickness_punching_unit'].setValue(spec.machine_specification_unit_name)
        }
      }, this)

    } else if (this.selectedMachine.display_name == "Bending" || this.selectedMachine.display_name == "bending") {
      item.vom_specifications.forEach(function (spec) {
        if (spec.master_specification_name == "Bending Length (Max)") {
          this.machineForm.controls['bending_length'].setValue(spec.machine_capacity)
          this.machineForm.controls['bending_length_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Free passage between pillars (Max)") {
          this.machineForm.controls['free_passage_between_pillars'].setValue(spec.machine_capacity)
          this.machineForm.controls['free_passage_between_pillars_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Bending aids") {
          this.machineForm.controls['bending_aids'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Support brackets") {
          this.machineForm.controls['support_brackets'].setValue(spec.machine_capacity)
        }
      }, this)

    } else if (this.selectedMachine.display_name == "Panel Bending" || this.selectedMachine.display_name == "panel bending") {
      item.vom_specifications.forEach(function (spec) {
        if (spec.master_specification_name == "Total number of panel benders") {
          this.machineForm.controls['total_number_of_panel_benders'].setValue(spec.machine_capacity)
        }
      }, this)

    } else if (this.selectedMachine.display_name == "Welding" || this.selectedMachine.display_name == "welding") {
      item.vom_specifications.forEach(function (spec) {
        if (spec.master_specification_name == "Welding Type") {
          this.machineForm.controls['welding_type'].setValue(spec.machine_capacity)

        } else if (spec.master_specification_name == "Max Seam Length") {
          this.machineForm.controls['max_seam_length'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_seam_length_unit'].setValue(spec.machine_specification_unit_name)

        }
      }, this)

    } else if (this.selectedMachine.display_name == "Straightening machine" || this.selectedMachine.display_name == 'straightening machine') {
      item.vom_specifications.forEach(function (spec) {
        if (spec.master_specification_name == "Sheet Width (Max)") {
          this.machineForm.controls['max_sheet_width'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_width_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Sheet Thickness (Max)") {
          this.machineForm.controls['sheet_thickness'].setValue(spec.machine_capacity)
          this.machineForm.controls['sheet_thickness_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "No. of rolls") {
          this.machineForm.controls['no_of_rolls'].setValue(spec.machine_capacity)

        }
      }, this)

    } else if (this.selectedMachine.display_name == "De-burring machine" || this.selectedMachine.display_name == 'de-burring machine') {
      item.vom_specifications.forEach(function (spec) {
        if (spec.master_specification_name == "Sheet Width (Max)") {
          this.machineForm.controls['max_sheet_width'].setValue(spec.machine_capacity)
          this.machineForm.controls['max_sheet_width_unit'].setValue(spec.machine_specification_unit_name)

        } else if (spec.master_specification_name == "Sheet Thickness (Max)") {
          this.machineForm.controls['sheet_thickness'].setValue(spec.machine_capacity)
          this.machineForm.controls['sheet_thickness_unit'].setValue(spec.machine_specification_unit_name)

        }
      }, this)

    } else {
      item.vom_specifications.forEach(function (spec) {
        this.setValueMachineSpec(spec)
      }, this)

      this.machineUnits = [] || this.machineUnits;
      if (this.machineUnits.length == 0) {
        this.onboardingService.getMachineUnits().subscribe(
          res => {
            this.machineUnits = res;
          }, err => {
            for (let i in err.error.errors) {
              this.toastr.error(err.error.errors[i]);
            }
          }
        );
      }
    }

  }

  setManufacturingTechnologyData(manufacturingTechnology = { id: 'others', name: "others" }) {
    // this.loaderService.display(true);

    this.machineForm.reset();
    this.setMachineFields();
    this.editMachineIndex = -1;
    (this.machineForm.controls['vom_specifications'] as FormArray).clear();
    this.selectedManufacturingTechnology = manufacturingTechnology;
    this.machineForm.controls['manufacturing_technology_id'].setValue(manufacturingTechnology.id)
    this.machineForm.controls['manufacturing_technology_name'].setValue(manufacturingTechnology.name)

    this.onboardingService.searchMachines(this.manufacturingTechnologyData.id, "").subscribe(
      res => {
        this.machines = res;
      },
      err => {
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      });

    if (this.selectedManufacturingTechnology.name == "Sheet Metal Manufacturing") {
      this.selectedMachine = { name: "lasercutting", display_name: "lasercutting" }
      this.machineForm.controls['machine_name'].setValue("lasercutting");
    } else {
      this.addMachineSpec();
      this.selectedMachine = { id: "0", name: "others", display_name: "Others" }
      this.machineUnits = [] || this.machineUnits;
      if (this.machineUnits.length == 0) {
        this.onboardingService.getMachineUnits().subscribe(
          res => {
            this.machineUnits = res;
            // this.loaderService.display(false);
          }, err => {
            for (let i in err.error.errors) {
              this.toastr.error(err.error.errors[i]);
            }
          }
        );
      }
    }
  }

  setValueMachineSpec(item) {
    (this.machineForm.get('vom_specifications') as FormArray).push(this.fb.group({
      master_specification_name: [item.master_specification_name, Validators.required],
      machine_capacity: [item.machine_capacity, Validators.required],
      machine_specification_unit_name: [item.machine_specification_unit_name, Validators.required],
    }));
  }

  submitMachineDetails() {
    console.log(this.machineForm.value)
    this.machineFormSubmitted = true;

    if (this.machineForm.valid) {
      var formValue = this.machineForm.value;
      var master_spec, machine_unit, name, brandName;
      var machine_spec = [];
      if (this.selectedMachine.display_name == "lasercutting" || this.selectedMachine.display_name =='Lasercutting') {
        machine_spec.push(
          { master_specification_name: "Laser Type", machine_capacity: formValue.laser_type, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Laser Power", machine_capacity: formValue.laser_power, machine_specification_unit_name: formValue.laser_power_unit },
          { master_specification_name: "Max Sheet Thickness Mild Steel", machine_capacity: formValue.max_sheet_thickness_mild_steel, machine_specification_unit_name: formValue.max_sheet_thickness_mild_steel_unit },
          { master_specification_name: "Max Sheet Thickness Stainless Steel", machine_capacity: formValue.max_sheet_thickness_stainless_steel, machine_specification_unit_name: formValue.max_sheet_thickness_stainless_steel_unit },
          { master_specification_name: "Max Sheet Thickness Aluminium", machine_capacity: formValue.max_sheet_thickness_aluminium, machine_specification_unit_name: formValue.max_sheet_thickness_aluminium_unit },
          { master_specification_name: "Max Sheet Thickness Copper", machine_capacity: formValue.max_sheet_thickness_copper, machine_specification_unit_name: formValue.max_sheet_thickness_copper_unit },
          { master_specification_name: "Max Sheet Thickness Brass", machine_capacity: formValue.max_sheet_thickness_brass, machine_specification_unit_name: formValue.max_sheet_thickness_brass_unit },
          { master_specification_name: "Working Range X", machine_capacity: formValue.working_range_x, machine_specification_unit_name: formValue.working_range_x_unit },
          { master_specification_name: "Working Range Y", machine_capacity: formValue.working_range_y, machine_specification_unit_name: formValue.working_range_y_unit },
          { master_specification_name: "Cutting Gas Oxygen", machine_capacity: formValue.cutting_gas_oxygen, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Cutting Gas Nitrogen", machine_capacity: formValue.cutting_gas_nitrogen, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Cutting Gas Compressed Air", machine_capacity: formValue.cutting_gas_compressed_air, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Marking Possible", machine_capacity: formValue.marking_possible, machine_specification_unit_name: "n/a" }
        )
      } else if (this.selectedMachine.display_name == "Punching" || this.selectedMachine.display_name == "punching") {
        machine_spec.push(
          { master_specification_name: "Punch Force", machine_capacity: formValue.punch_force, machine_specification_unit_name: formValue.punch_force_unit },
          { master_specification_name: "Sheet Thickness (Max)", machine_capacity: formValue.sheet_thickness, machine_specification_unit_name: formValue.sheet_thickness_unit },
          { master_specification_name: "Tool Stations", machine_capacity: formValue.tool_stations, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Tooling Diameter (Max)", machine_capacity: formValue.tooling_diameter, machine_specification_unit_name: formValue.tooling_diameter_unit },
          { master_specification_name: "No. of indexing stations", machine_capacity: formValue.no_of_indexing_stations, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Indexing diameter(Max)", machine_capacity: formValue.indexing_diameter, machine_specification_unit_name: formValue.indexing_diameter_unit },
          { master_specification_name: "Additional Process Available", machine_capacity: formValue.additional_process_available, machine_specification_unit_name: "" },
          { master_specification_name: "Forming Max Dimensions", machine_capacity: formValue.forming_max_dimensions, machine_specification_unit_name: formValue.forming_max_dimensions_unit },
          { master_specification_name: "Forming Max Height", machine_capacity: formValue.forming_max_height, machine_specification_unit_name: formValue.forming_max_height_unit },
          { master_specification_name: "Max Angle", machine_capacity: formValue.forming_max_angle, machine_specification_unit_name: formValue.forming_max_angle_unit },
          { master_specification_name: "Working Range X", machine_capacity: formValue.working_range_x, machine_specification_unit_name: formValue.working_range_x_unit },
          { master_specification_name: "Working Range Y", machine_capacity: formValue.working_range_y, machine_specification_unit_name: formValue.working_range_y_unit },
        )
      } else if (this.selectedMachine.display_name == "Combi Machines" || this.selectedMachine.display_name == "combi machines") {
        machine_spec.push(
          { master_specification_name: "Laser Type", machine_capacity: formValue.laser_type, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Laser Power", machine_capacity: formValue.laser_power, machine_specification_unit_name: formValue.laser_power_unit },
          { master_specification_name: "Max Sheet Thickness Mild Steel", machine_capacity: formValue.max_sheet_thickness_mild_steel, machine_specification_unit_name: formValue.max_sheet_thickness_mild_steel_unit },
          { master_specification_name: "Max Sheet Thickness Stainless Steel", machine_capacity: formValue.max_sheet_thickness_stainless_steel, machine_specification_unit_name: formValue.max_sheet_thickness_stainless_steel_unit },
          { master_specification_name: "Max Sheet Thickness Aluminium", machine_capacity: formValue.max_sheet_thickness_aluminium, machine_specification_unit_name: formValue.max_sheet_thickness_aluminium_unit },
          { master_specification_name: "Max Sheet Thickness Copper", machine_capacity: formValue.max_sheet_thickness_copper, machine_specification_unit_name: formValue.max_sheet_thickness_copper_unit },
          { master_specification_name: "Max Sheet Thickness Brass", machine_capacity: formValue.max_sheet_thickness_brass, machine_specification_unit_name: formValue.max_sheet_thickness_brass_unit },
          { master_specification_name: "Working Range X", machine_capacity: formValue.working_range_x, machine_specification_unit_name: formValue.working_range_x_unit },
          { master_specification_name: "Working Range Y", machine_capacity: formValue.working_range_y, machine_specification_unit_name: formValue.working_range_y_unit },
          { master_specification_name: "Cutting Gas Oxygen", machine_capacity: formValue.cutting_gas_oxygen, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Cutting Gas Nitrogen", machine_capacity: formValue.cutting_gas_nitrogen, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Cutting Gas Compressed Air", machine_capacity: formValue.cutting_gas_compressed_air, machine_specification_unit_name: "n/a" }, { master_specification_name: "Marking Possible", machine_capacity: formValue.marking_possible, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Max Sheet Thickness Punching", machine_capacity: formValue.max_sheet_thickness_punching, machine_specification_unit_name: formValue.max_sheet_thickness_punching_unit },
        )
      } else if (this.selectedMachine.display_name == "Bending" || this.selectedMachine.display_name == "bending") {
        machine_spec.push(
          { master_specification_name: "Bending Length (Max)", machine_capacity: formValue.bending_length, machine_specification_unit_name: formValue.bending_length_unit },
          { master_specification_name: "Free passage between pillars (Max)", machine_capacity: formValue.free_passage_between_pillars, machine_specification_unit_name: formValue.free_passage_between_pillars_unit },
          { master_specification_name: "Bending aids", machine_capacity: formValue.bending_aids, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Support brackets", machine_capacity: formValue.support_brackets, machine_specification_unit_name: "n/a" },
        )
      } else if (this.selectedMachine.display_name == "panel bending") {
        machine_spec.push(
          { master_specification_name: "Total number of panel benders", machine_capacity: formValue.total_number_of_panel_benders, machine_specification_unit_name: "n/a" },
        )
      } else if (this.selectedMachine.display_name == "Welding" || this.selectedMachine.display_name == "welding") {
        machine_spec.push(
          { master_specification_name: "Welding Type", machine_capacity: formValue.welding_type, machine_specification_unit_name: "n/a" },
          { master_specification_name: "Max Seam Length", machine_capacity: formValue.max_seam_length, machine_specification_unit_name: formValue.max_seam_length_unit },
        )
      } else if (this.selectedMachine.display_name == "straightening machine" || this.selectedMachine.display_name =='Straightening Machine') {
        machine_spec.push(
          { master_specification_name: "Sheet Width (Max)", machine_capacity: formValue.max_sheet_width, machine_specification_unit_name: formValue.max_sheet_width_unit },
          { master_specification_name: "Sheet Thickness (Max)", machine_capacity: formValue.sheet_thickness, machine_specification_unit_name: formValue.sheet_thickness_unit },
          { master_specification_name: "No. of rolls", machine_capacity: formValue.no_of_rolls, machine_specification_unit_name: "n/a" },
        )
      } else if (this.selectedMachine.display_name == "de-burring machine" || this.selectedMachine.display_name =='De-burring machine') {
        machine_spec.push(
          { master_specification_name: "Sheet Width (Max)", machine_capacity: formValue.max_sheet_width, machine_specification_unit_name: formValue.max_sheet_width_unit },
          { master_specification_name: "Sheet Thickness (Max)", machine_capacity: formValue.sheet_thickness, machine_specification_unit_name: formValue.sheet_thickness_unit },
        )
      } else {
        formValue.vom_specifications.forEach(function (item, index) {
          master_spec = item.master_specification_name.name || item.master_specification_name;
          machine_unit = item.machine_specification_unit_name.name || item.machine_specification_unit_name;

          machine_spec.push({
            master_specification_name: master_spec,
            machine_capacity: item.machine_capacity,
            machine_specification_unit_name: machine_unit,
          })
          console.log(machine_unit)
        })
      }

      name = formValue.machine_name.name || formValue.machine_name;
      brandName = formValue.brand_name.name || formValue.brand_name;
      if (this.editMachineIndex == -1) {
        this.machineDetailsArray.push({
          vendor_machine_name: name,
          brand_name: brandName,
          model_number: formValue.model_number,
          manufacturing_technology_id: formValue.manufacturing_technology_id,
          manufacturing_technology_name: this.selectedManufacturingTechnology.name,
          number_of_machines: formValue.number_of_machines,
          spare_capacity: formValue.spare_capacity,
          machine_speciality: formValue.machine_speciality,
          is_available_for_rent: formValue.is_available_for_rent,
          address_id: formValue.address_id,
          vom_specifications: machine_spec,
          vom_attachments: formValue.vom_attachments
        })
      }
      else {
        this.machineDetailsArray[this.editMachineIndex] = {
          vendor_machine_name: name,
          brand_name: brandName,
          model_number: formValue.model_number,
          manufacturing_technology_id: formValue.manufacturing_technology_id,
          manufacturing_technology_name: this.selectedManufacturingTechnology.name,
          number_of_machines: formValue.number_of_machines,
          spare_capacity: formValue.spare_capacity,
          machine_speciality: formValue.machine_speciality,
          is_available_for_rent: formValue.is_available_for_rent,
          address_id: formValue.address_id,
          vom_specifications: machine_spec,
          vom_attachments: formValue.vom_attachments
        }
      }

      this.editMachineIndex = -1;
      this.machineFormSubmitted = false;
      console.log(this.machineDetailsArray)
      // console.log(this.machineDetailsArray)
      this.dialogref.close({ data: this.machineDetailsArray, edited_machine_index: this.machine_index, message: 'success' });
    }
    else {
      this.toastr.error('Please Fill all the appropriate fields', 'Error');
      return this.machineForm.markAllAsTouched();
    }

  }

  close() {
    this.dialogref.close({ message: 'failed' });
  }

}
